import { Injector, runInInjectionContext } from '@angular/core';
import { AccCompareCard } from '@features/social-analysis/social-listening/models/I-compare';
import { CompareHttpBuilder } from '@features/social-analysis/social-listening/services/compare.http';
import { PageFiltersState } from './page-filters.store';
import { BaseState } from './state.store';

export class CompareState extends BaseState<AccCompareCard> {
    #http!: CompareHttpBuilder;

    constructor(injector: Injector) {
        super();
        runInInjectionContext(injector, () => (this.#http = new CompareHttpBuilder()));
    }

    reqData(pageFilters: PageFiltersState, igAcc: string) {
        this.#http.reqData(this, pageFilters, igAcc);
    }
}
